export default function initPage($){

    function toggleAccordionSection($section) {
        var $panel = $section.find(".accordian-expandable").first();
        var $button = $section.find(".accordian-toggle").first();

        if ($section.hasClass("closed")) {
            $panel.slideDown(function(){
                $section.addClass("open").removeClass("closed");
            });
            if ($button.length) {
                $button.attr("aria-expanded", "true");
            }
        } else {
            $panel.slideUp(function(){
                $section.addClass("closed").removeClass("open");
            });
            if ($button.length) {
                $button.attr("aria-expanded", "false");
            }
        }
    }

    // Preferred pattern: <h2><button class="accordian-toggle" aria-expanded ...>
    $(document).on("click", ".nets-accordian .accordian-toggle", function(e){
        e.preventDefault();
        toggleAccordionSection($(this).closest(".accordian-section"));
    });

    // Legacy pattern: heading is the click target. Skip when a real
    // .accordian-toggle button exists in the section so we don't double-fire.
    // Also skip sections without an .accordian-expandable panel (e.g. the
    // static "Acknowledgements" block on the exhibition page).
    $(".nets-accordian h2, .nets-accordian h3").on("click", function(e){
        var $section = $(this).parents(".accordian-section");
        if ($section.find(".accordian-toggle").length) {
            return;
        }
        if (!$section.find(".accordian-expandable").length) {
            return;
        }
        e.preventDefault();
        toggleAccordionSection($section);
    });

    // Primary-menu submenus: hover opens on hover-capable devices, but on
    // touch devices the parent link must be tappable to open the dropdown.
    // First tap opens the dropdown; second tap follows the link.
    function closeAllSubmenus(except) {
        document.querySelectorAll(".main-navigation .nav-menu > .menu-item-has-children.is-open").forEach(function(li) {
            if (li !== except) {
                li.classList.remove("is-open");
            }
        });
    }

    document.addEventListener("click", function(event) {
        var parentLink = event.target.closest(".main-navigation .nav-menu > .menu-item-has-children > a");
        if (parentLink) {
            var li = parentLink.parentNode;
            if (!li.querySelector(".sub-menu")) return;

            var isResponsiveMenu = window.matchMedia && window.matchMedia("(max-width: 1199.98px)").matches;
            if (isResponsiveMenu) return; // responsive menu shows submenus inline

            var hasHover = !window.matchMedia || window.matchMedia("(hover: hover)").matches;
            if (hasHover) return; // hover handles it

            if (!li.classList.contains("is-open")) {
                event.preventDefault();
                closeAllSubmenus(li);
                li.classList.add("is-open");
            }
            return;
        }

        if (!event.target.closest(".main-navigation .sub-menu")) {
            closeAllSubmenus(null);
        }
    });

    document.addEventListener("keydown", function(event) {
        if (event.key === "Escape") {
            closeAllSubmenus(null);
        }
    });
}
